import { OtherOrgBanner } from "@/shared/components";

/**
 * Says the trigger belongs to another org than the one the reader is working
 * in, with a switch to it. Renders nothing for a trigger in the selected org.
 */
export function TriggerOtherOrgBanner({
  orgId,
  className,
}: {
  orgId: string;
  className?: string;
}) {
  return (
    <OtherOrgBanner orgId={orgId} className={className}>
      {({ orgName, currentOrgName }) =>
        `This trigger belongs to org "${orgName}". You're working in ${currentOrgName}.`
      }
    </OtherOrgBanner>
  );
}
